"use client";
import React from "react";
import { useState, useEffect } from "react";
import type { FeatureSection } from "@/components/features";
import { getBackgroundStyle } from "@/lib/background";
import { renderIcon } from "@/lib/icon";
import Image from "next/image";

export default function FeaturesCarousel({ data }: FeatureSection) {
  const { title, subtitle, features = [], background } = data || {};
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % features.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [features.length]);

  const bgStyle = getBackgroundStyle(background);

  return (
    <section className="py-20 px-4 relative" style={bgStyle}>
      {background?.type === "image" && background?.value && (
        <Image
          src={background.value}
          alt={title || subtitle || ""}
          fill
          priority
          className="object-cover object-center z-0"
        />
      )}
      <div className="max-w-4xl mx-auto text-center relative z-10">
        {title && (
          <h2 className="text-3xl font-bold mb-2 text-foreground">{title}</h2>
        )}
        {subtitle && <p className="text-muted-foreground mb-8">{subtitle}</p>}

        <div className="bg-white shadow-md rounded-xl p-8 transition-all duration-500">
          <div className="text-4xl mb-4">
            {features[current]?.icon &&
              renderIcon({ icon: features[current].icon, size: 40 })}
          </div>
          <h3 className="text-xl font-semibold text-foreground">
            {features[current]?.title}
          </h3>
          <p className="text-muted-foreground mt-2">
            {features[current]?.description}
          </p>
          {features[current]?.link?.href && (
            <a
              href={features[current].link.href}
              className="text-primary underline text-sm mt-2 inline-block"
            >
              {features[current].link.text || "Learn more"}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
